import { labelTitleConverter, newModulePermissions } from '@src/utils';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { selectGlobal } from '@store/slices/global/global';
import { selectUsers, setNewPermissions } from '@store/slices/users/usersSlice';
import { useLayoutEffect } from 'react';
import { CONTRACTOR_USER } from '@routes/helpers';

// import { mockPermissions } from '@src/mock-data';
interface Permission {
  id: number;
  typeId: number;
  name: string;
  module: string;
  lite: boolean;
  abilities: any[];
}

export const useSetPermissions = () => {
  const dispatch = useAppDispatch();
  const { currentPath } = useAppSelector(selectGlobal);
  const { userInfo, userType } = useAppSelector(selectUsers);
  const rawPermissions: Permission[] = userInfo?.permissions ?? [];

  const grouped = Object.groupBy(rawPermissions, (item) => item.module);

  const moduleMap: Record<string, { id: number; name: string }> = {
    payor: { id: 1, name: 'Payors' },
    member: { id: 2, name: 'Members' },
    standingOrder: { id: 3, name: 'StandingOrder' },
    dashboard: { id: 4, name: 'Dashboard' },
    admin: { id: 5, name: 'Admin' },
    ride: { id: 6, name: 'Rides' },
    contractor: { id: 7, name: 'Contractors' },
    place: { id: 8, name: 'Places' },
    assignment: { id: 9, name: 'Assignments' },
    monitoring: { id: 10, name: 'Monitoring' },
    home: { id: 11, name: 'Home' },
    reporting: { id: 12, name: 'Dashboard' },
    contractorPortal: { id: 13, name: 'ContractorPortal' },
  };

  const mutatedPermissions = Object.entries(grouped).map(
    ([module, permissions]) => {
      const first = (permissions as Permission[])[0];
      const typeId = first?.typeId ?? -1;
      const { id, name } = moduleMap[module] ?? {
        id: -1,
        name: module,
      };

      return {
        id,
        name,
        typeId,
        permissions: permissions as Permission[],
      };
    }
  );
  // TODO this was fixed // check and remove
  // useLayoutEffect(() => {
  //   (async () => {
  //     if (!currentPath) return;
  //     const adjustPath =
  //       userType === CONTRACTOR_USER ? 'contractorPortal' : currentPath;
  //     const modulePermissionsArray = newModulePermissions(
  //       mutatedPermissions,
  //       // labelTitleConverter[currentPath]
  //       labelTitleConverter[adjustPath]
  //     );
  //
  //     dispatch(setNewPermissions(modulePermissionsArray));
  //   })();
  // }, [currentPath, userInfo]);

  useLayoutEffect(() => {
    if (!currentPath || !userInfo) return;

    const adjustPath =
      userType === CONTRACTOR_USER ? 'contractorPortal' : currentPath;

    const modulePermissionsArray = newModulePermissions(
      mutatedPermissions,
      labelTitleConverter[adjustPath]
    );

    dispatch(
      setNewPermissions({
        permissions: modulePermissionsArray,
        path: currentPath,
      })
    );
  }, [currentPath, userInfo, userType]);
};
